"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */
const react_1 = require("react");
const antd_1 = require("antd");
const react_router_dom_1 = require("react-router-dom");
const react_query_1 = require("@tanstack/react-query");
const ConfigurationDetails_1 = __importDefault(require("./ConfigurationDetails"));
const ConfigItemsList_1 = __importDefault(require("./ConfigItems/ConfigItemsList"));
const NewConfigItem_1 = __importDefault(require("./ConfigItems/NewConfigItem"));
const ManageConfigItem_1 = __importDefault(require("./ConfigItems/ManageConfigItem"));
const configurations_1 = require("../../services/configurations");
const queryKeys_1 = __importDefault(require("../../constants/queryKeys"));
const ManageConfiguration = () => {
    var _a, _b, _c, _d, _e, _f, _g;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const { id } = (0, react_router_dom_1.useParams)();
    const incomingState = location.state;
    const [configDetails, setConfigDetails] = (0, react_1.useState)([]);
    const [showNewDrawer, setShowNewDrawer] = (0, react_1.useState)(false);
    const [showEditDrawer, setShowEditDrawer] = (0, react_1.useState)(false);
    const [configParent, setConfigParent] = (0, react_1.useState)('');
    const [itemIdToEdit, setItemIdToEdit] = (0, react_1.useState)('');
    const [version, setVersion] = (0, react_1.useState)(0);
    const [activeLocale, setActiveLocale] = (0, react_1.useState)('');
    const { data } = (0, react_query_1.useQuery)({
        queryKey: [queryKeys_1.default.CONFIGURATIONS.CONFIG_DETAILS, id],
        queryFn: (0, configurations_1.getConfigById)(id),
        enabled: !!id,
    });
    const currentRecord = incomingState || data;
    const { isLoading: isConfigDetailsDataLoading, data: configDetailsData } = (0, react_query_1.useQuery)({
        queryKey: [queryKeys_1.default.CONFIGURATIONS.CONFIG_DETAILS, currentRecord],
        queryFn: () => {
            const { tenantId, appId, configType, configCode } = currentRecord;
            return (0, configurations_1.getGroupedConfigurations)(tenantId, appId, configType, configCode);
        },
        enabled: !!currentRecord,
        refetchOnMount: 'always',
        onError: (err) => {
            const { status, data: { msg } } = err.response;
            switch (status) {
                case 404: return navigate('/configurations/404', { state: { comingFrom: 'manage' } });
                case 500: return navigate('/configurations/500');
                default: antd_1.message.error(msg);
            }
        },
    });
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (configDetailsData) {
            setConfigDetails(configDetailsData);
            setActiveLocale((_b = (_a = configDetailsData[0]) === null || _a === void 0 ? void 0 : _a.defaultLocale) === null || _b === void 0 ? void 0 : _b.code);
        }
    }, [configDetailsData]);
    // TODO: combine two functions below to reuse the logic
    const displayNewConfigItemDrawer = (configItemId) => {
        !showNewDrawer ? setConfigParent(configItemId) : setConfigParent('');
        setShowNewDrawer(!showNewDrawer);
    };
    const displayEditConfigItemDrawer = (configItemId) => {
        !showEditDrawer ? setItemIdToEdit(configItemId) : setItemIdToEdit('');
        setShowEditDrawer(!showEditDrawer);
    };
    const handleVersionChange = (value) => setVersion(configDetails.length - value);
    const handleActiveLocaleChange = (code) => setActiveLocale(code);
    const activeLocales = (_a = configDetails[version]) === null || _a === void 0 ? void 0 : _a.locales.filter((locale) => locale.isActive);
    return ((0, jsx_runtime_1.jsx)(antd_1.Spin, Object.assign({ spinning: isConfigDetailsDataLoading, tip: 'Loading...' }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Card, Object.assign({ bordered: false, style: { margin: '0.5rem' } }, { children: [(0, jsx_runtime_1.jsx)(ConfigurationDetails_1.default, Object.assign({}, configDetails[version], { activeLocale: activeLocale, activeLocales: activeLocales, versionCount: configDetails.length, handleAddItem: displayNewConfigItemDrawer, handleVersionChange: handleVersionChange, handleActiveLocaleChange: handleActiveLocaleChange })), (0, jsx_runtime_1.jsx)(ConfigItemsList_1.default, { isEditable: (_b = configDetails[0]) === null || _b === void 0 ? void 0 : _b.checkedOut, checkedOutBy: (_c = configDetails[0]) === null || _c === void 0 ? void 0 : _c.checkedOutBy, activeLocale: activeLocale, activeLocales: activeLocales, configItems: (_d = configDetails[version]) === null || _d === void 0 ? void 0 : _d.configItems, onAdd: displayNewConfigItemDrawer, onEdit: displayEditConfigItemDrawer }), (0, jsx_runtime_1.jsx)(NewConfigItem_1.default, { configId: (_e = configDetails[0]) === null || _e === void 0 ? void 0 : _e.configId, tenantId: (_f = configDetails[0]) === null || _f === void 0 ? void 0 : _f.tenantId, parent: configParent, activeLocales: activeLocales, show: showNewDrawer, handleDrawer: setShowNewDrawer }), (0, jsx_runtime_1.jsx)(ManageConfigItem_1.default, { configItemId: itemIdToEdit, tenantId: (_g = configDetails[0]) === null || _g === void 0 ? void 0 : _g.tenantId, activeLocales: activeLocales, show: showEditDrawer, handleDrawer: setShowEditDrawer })] })) })));
};
exports.default = ManageConfiguration;
